<div class="container-fluid" >
    <div  style="display: inline;block-size: 10%;">
    <!--Header-->
      <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 15px;">
         <div class="col-md-4 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
            <h2 style="font-size:25px"> Production Output </h2>
        </div>
        <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
          <span *ngIf="productionOutPutList.length > 0" class="search">
            <span class="fa fa-search"></span>
            <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
              (keyup)="applyFilter($event)" #input
              style="text-align: left; background-color: white !important;  display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 30% !important; height: 31px !important;"
              type="text">
          </span>
          <span *ngIf="exportToExcel.length > 0" (click)="exportToExcelActivities();" class="orangeButton"
            style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
            <span>
              <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
            </span>
          </span>
          <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
            <span class="darkBlueButton"
                style="font-size: 13px; display: inline-block; margin-left: 10px;"
                (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Production
            </span>
        </div>
        </div>
      </div>
    </div>

    <!--Filter-->
    <div class="col-md-12 col-xs-12 col-sm-12" style="margin-bottom: 25px;">
      <div style="display: inline-block;" >
        <label  style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
            for="sel1">Month : </label>
    </div>

    <div style="display: inline-block;margin-left: 10px;">
        <select  class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 100px;cursor: pointer; font-size: 13px;" [(ngModel)]="monthDisplay" 
        (change) ="trasYearChange()">
        <!-- <option [value]="i.number" *ngFor="let i of months;"  >{{i.display}}</option> -->
        <option *ngFor="let i of months;">{{i.display}}</option>
      </select>
    </div>
    </div>
 
      <!--Data Table-->
    <div class="wrapper" style="text-overflow: ellipsis; white-space: nowrap;"
      *ngIf="dataSource.data.length > 0" #mtlAviaTable>
      <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow" style="width: 50%;">
        <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
        
            <ng-container matColumnDef="PrdName" style="cursor: pointer;">
        
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Product</label>
            </th>
            <td mat-cell *matCellDef="let element" style="width: 25% !important;"> {{element.PrdName}} </td>
            </ng-container>
        
            <ng-container matColumnDef="LaunchQty">
            <th class="header header-Table" style="cursor: pointer; padding-left: 6% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Launched</label>
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.LaunchQty}} </td>
            </ng-container>
        
            <ng-container matColumnDef="ComplnQty">
                <th class="header header-Table" style="cursor: pointer; padding-left: 6% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Output</label>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.ComplnQty}} </td>
            </ng-container>

            <ng-container matColumnDef="Unit">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label> Unit </label>
                </th>
                <td mat-cell *matCellDef="let element" style=" width: 7%;"> {{element.Unit}} </td>
                </ng-container>

            <ng-container matColumnDef="RejPer">
                <th class="header header-Table" style="cursor: pointer;padding-left: 3% !important; padding-right: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Rejection</label>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%; padding-right: 3% !important"> {{element.RejPer}} % </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
        </table>
        <!-- Angular 8 pagination -->
        <mat-paginator [pageSizeOptions]="[10,20,30,40,50]" showFirstLastButtons>
        </mat-paginator>
       </div>
    </div>
    
    <div *ngIf="productionOutPutList.length == 0">
      <div style="margin:15px" class="nrf">No records found.</div>
    </div>
</div>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>